import { useState } from 'react';
import Layout from '../../../../components/layout/Layout';

interface Participante {
  id: number;
  nome: string;
  email: string;
  departamento: string;
  cargo: string;
  publicoAlvo: string;
  atendimentos: number;
  status: 'ativo' | 'inativo' | 'bloqueado' | 'em_analise';
  avatar?: string;
  saldoReais?: number;
  premiosRecebidos?: Array<{
    id: number;
    nome: string;
    valor: number;
    data: string;
    tipo: 'dinheiro' | 'produto' | 'viagem';
  }>;
  historicoEstornos?: Array<{
    id: number;
    valor: number;
    motivo: string;
    solicitadoPor: string;
    dataHora: string;
    status: 'pendente' | 'aprovado' | 'rejeitado';
  }>;
  informacoesDivergentes?: {
    emailPlataforma: string;
    emailInformado: string;
    telefonePlataforma: string;
    telefoneInformado: string;
    dataAnalise: string;
    motivoAnalise: string;
  };
}

export default function ParticipantesCampanhaPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('todos');
  const [showEstornoModal, setShowEstornoModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAnaliseModal, setShowAnaliseModal] = useState(false);
  const [showVincularModal, setShowVincularModal] = useState(false);
  const [participanteSelecionado, setParticipanteSelecionado] = useState<Participante | null>(null);
  const [novoEstorno, setNovoEstorno] = useState({
    valor: '',
    motivo: ''
  });
  const [searchVincular, setSearchVincular] = useState('');
  const [participantesSelecionados, setParticipantesSelecionados] = useState<number[]>([]);

  // Informações da campanha selecionada
  const campanhaAtual = {
    nome: 'Campanha de Vendas Q1 2024',
    periodo: '01/01/2024 - 31/03/2024',
    status: 'ativa'
  };

  // Lista de todos os participantes cadastrados no sistema
  const [todosParticipantes] = useState<Participante[]>([
    {
      id: 1,
      nome: 'Ana Silva',
      email: 'ana.silva@empresa.com',
      departamento: 'Vendas',
      cargo: 'Consultor de Vendas',
      publicoAlvo: 'PF',
      atendimentos: 3,
      status: 'ativo',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20smiling%20corporate%20headshot%20portrait%20simple%20white%20background%20clean%20modern%20style&width=100&height=100&seq=1&orientation=squarish',
      saldoReais: 1250.00,
      premiosRecebidos: [
        { id: 1, nome: 'Bônus Performance', valor: 500.00, data: '2024-02-15', tipo: 'dinheiro' },
        { id: 2, nome: 'Vale-compras', valor: 750.00, data: '2024-03-01', tipo: 'produto' }
      ],
      historicoEstornos: []
    },
    {
      id: 2,
      nome: 'Carlos Eduardo Lima',
      email: 'carlos.lima@empresa.com',
      departamento: 'Marketing',
      cargo: 'Analista de Marketing',
      publicoAlvo: 'CLT',
      atendimentos: 7,
      status: 'bloqueado',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20man%20smiling%20corporate%20headshot%20portrait%20simple%20white%20background%20clean%20modern%20style&width=100&height=100&seq=2&orientation=squarish',
      saldoReais: 2200.00,
      premiosRecebidos: [
        { id: 3, nome: 'Bônus Trimestral', valor: 1200.00, data: '2024-01-30', tipo: 'dinheiro' },
        { id: 4, nome: 'Viagem Corporativa', valor: 1500.00, data: '2024-02-15', tipo: 'viagem' }
      ],
      historicoEstornos: [
        {
          id: 1,
          valor: 500.00,
          motivo: 'Dados fraudulentos em vendas',
          solicitadoPor: 'Maria Santos - Supervisora',
          dataHora: '2024-02-22 09:15:00',
          status: 'aprovado'
        }
      ]
    },
    {
      id: 3,
      nome: 'Mariana Costa',
      email: 'mariana.costa@empresa.com',
      departamento: 'RH',
      cargo: 'Coordenadora de RH',
      publicoAlvo: 'PJ',
      atendimentos: 2,
      status: 'ativo',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20smiling%20corporate%20headshot%20portrait%20simple%20white%20background%20clean%20modern%20style&width=100&height=100&seq=3&orientation=squarish',
      saldoReais: 890.00,
      premiosRecebidos: [
        { id: 5, nome: 'Bônus Vendas', valor: 890.00, data: '2024-02-28', tipo: 'dinheiro' }
      ],
      historicoEstornos: []
    },
    {
      id: 4,
      nome: 'Pedro Almeida',
      email: 'pedro.almeida@empresa.com',
      departamento: 'TI',
      cargo: 'Desenvolvedor',
      publicoAlvo: 'MEI',
      atendimentos: 12,
      status: 'ativo',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20man%20smiling%20corporate%20headshot%20portrait%20simple%20white%20background%20clean%20modern%20style&width=100&height=100&seq=4&orientation=squarish',
      saldoReais: 650.00,
      premiosRecebidos: [
        { id: 6, nome: 'Prêmio Criatividade', valor: 650.00, data: '2024-02-20', tipo: 'produto' }
      ],
      historicoEstornos: []
    },
    {
      id: 5,
      nome: 'Juliana Rodrigues',
      email: 'juliana.rodrigues@empresa.com',
      departamento: 'Financeiro',
      cargo: 'Analista Financeiro',
      publicoAlvo: 'AUTÔNOMO',
      atendimentos: 5,
      status: 'bloqueado',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20smiling%20corporate%20headshot%20portrait%20simple%20white%20background%20clean%20modern%20style&width=100&height=100&seq=5&orientation=squarish',
      saldoReais: 1850.00,
      premiosRecebidos: [
        { id: 7, nome: 'Bônus Atendimento', valor: 800.00, data: '2024-02-10', tipo: 'dinheiro' },
        { id: 8, nome: 'Prêmio Excelência', valor: 1050.00, data: '2024-02-25', tipo: 'produto' }
      ],
      historicoEstornos: [
        {
          id: 2,
          valor: 300.00,
          motivo: 'Violação de regras de conduta',
          solicitadoPor: 'João Silva - Administrador',
          dataHora: '2024-03-01 14:30:00',
          status: 'aprovado'
        }
      ]
    },
    {
      id: 6,
      nome: 'Fernanda Lima',
      email: 'fernanda.lima@empresa.com',
      departamento: 'Marketing',
      cargo: 'Supervisor de Marketing',
      publicoAlvo: 'PF',
      atendimentos: 8,
      status: 'em_analise',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20smiling%20corporate%20headshot%20portrait%20simple%20white%20background%20clean%20modern%20style&width=100&height=100&seq=6&orientation=squarish',
      saldoReais: 1420.00,
      premiosRecebidos: [
        { id: 9, nome: 'Bônus Iniciante', valor: 320.00, data: '2024-03-05', tipo: 'dinheiro' }
      ],
      historicoEstornos: [],
      informacoesDivergentes: {
        emailPlataforma: 'fernanda.lima@empresa.com',
        emailInformado: 'fernanda.lima.marketing@gmail.com',
        telefonePlataforma: '(11) 98765-4321',
        telefoneInformado: '(11) 99876-5432',
        dataAnalise: '2024-03-10 14:30:00',
        motivoAnalise: 'Divergência entre email e telefone informados pelo usuário e dados da plataforma'
      }
    },
    {
      id: 7,
      nome: 'Camila Souza',
      email: 'camila.souza@empresa.com',
      departamento: 'RH',
      cargo: 'Analista de RH',
      publicoAlvo: 'CLT',
      atendimentos: 1,
      status: 'em_analise',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20smiling%20corporate%20headshot%20portrait%20simple%20white%20background%20clean%20modern%20style&width=100&height=100&seq=7&orientation=squarish',
      saldoReais: 980.00,
      premiosRecebidos: [],
      historicoEstornos: [],
      informacoesDivergentes: {
        emailPlataforma: 'camila.souza@empresa.com',
        emailInformado: 'camila.s.rh@outlook.com',
        telefonePlataforma: '(11) 97654-3210',
        telefoneInformado: '(11) 96543-2109',
        dataAnalise: '2024-03-08 10:15:00',
        motivoAnalise: 'Dados de contato não conferem com informações do sistema'
      }
    },
    {
      id: 8,
      nome: 'Rafael Barbosa',
      email: 'rafael.barbosa@empresa.com',
      departamento: 'Operações',
      cargo: 'Coordenador de Operações',
      publicoAlvo: 'PJ',
      atendimentos: 15,
      status: 'bloqueado',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20man%20smiling%20corporate%20headshot%20portrait%20simple%20white%20background%20clean%20modern%20style&width=100&height=100&seq=8&orientation=squarish',
      saldoReais: 2100.00,
      premiosRecebidos: [
        { id: 10, nome: 'Bônus Anual', valor: 2100.00, data: '2024-01-15', tipo: 'dinheiro' }
      ],
      historicoEstornos: [
        {
          id: 3,
          valor: 200.00,
          motivo: 'Revisão de metas não atingidas',
          solicitadoPor: 'Carlos Oliveira - Gerente',
          dataHora: '2024-03-05 16:45:00',
          status: 'pendente'
        }
      ]
    },
    {
      id: 9,
      nome: 'Thiago Pereira',
      email: 'thiago.pereira@empresa.com',
      departamento: 'Vendas',
      cargo: 'Vendedor Sênior',
      publicoAlvo: 'MEI',
      atendimentos: 9,
      status: 'bloqueado',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20man%20smiling%20corporate%20headshot%20portrait%20simple%20white%20background%20clean%20modern%20style&width=100&height=100&seq=9&orientation=squarish',
      saldoReais: 3200.00,
      premiosRecebidos: [
        { id: 11, nome: 'Bônus Top Vendedor', valor: 1500.00, data: '2024-02-01', tipo: 'dinheiro' },
        { id: 12, nome: 'Prêmio Destaque', valor: 1700.00, data: '2024-02-20', tipo: 'produto' }
      ],
      historicoEstornos: []
    },
    {
      id: 10,
      nome: 'Lucas Martins',
      email: 'lucas.martins@empresa.com',
      departamento: 'TI',
      cargo: 'Analista de Sistemas',
      publicoAlvo: 'AUTÔNOMO',
      atendimentos: 4,
      status: 'bloqueado',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20man%20smiling%20corporate%20headshot%20portrait%20simple%20white%20background%20clean%20modern%20style&width=100&height=100&seq=10&orientation=squarish',
      saldoReais: 750.00,
      premiosRecebidos: [],
      historicoEstornos: []
    },
    {
      id: 11,
      nome: 'Beatriz Santos',
      email: 'beatriz.santos@empresa.com',
      departamento: 'Atendimento',
      cargo: 'Atendente',
      publicoAlvo: 'CLT',
      atendimentos: 6,
      status: 'ativo',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20smiling%20corporate%20headshot%20portrait%20simple%20white%20background%20clean%20modern%20style&width=100&height=100&seq=11&orientation=squarish',
      saldoReais: 540.00,
      premiosRecebidos: [],
      historicoEstornos: []
    },
    {
      id: 12,
      nome: 'Roberto Mendes',
      email: 'roberto.mendes@empresa.com',
      departamento: 'Suporte',
      cargo: 'Analista de Suporte',
      publicoAlvo: 'PF',
      atendimentos: 11,
      status: 'inativo',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20man%20smiling%20corporate%20headshot%20portrait%20simple%20white%20background%20clean%20modern%20style&width=100&height=100&seq=12&orientation=squarish',
      saldoReais: 0,
      premiosRecebidos: [],
      historicoEstornos: []
    },
    // Participantes adicionais não vinculados à campanha
    {
      id: 13,
      nome: 'Patricia Oliveira',
      email: 'patricia.oliveira@empresa.com',
      departamento: 'Comercial',
      cargo: 'Gerente Comercial',
      publicoAlvo: 'PJ',
      atendimentos: 0,
      status: 'ativo',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20smiling%20corporate%20headshot%20portrait%20simple%20white%20background%20clean%20modern%20style&width=100&height=100&seq=13&orientation=squarish',
      saldoReais: 0,
      premiosRecebidos: [],
      historicoEstornos: []
    },
    {
      id: 14,
      nome: 'Ricardo Santos',
      email: 'ricardo.santos@empresa.com',
      departamento: 'Logística',
      cargo: 'Coordenador de Logística',
      publicoAlvo: 'CLT',
      atendimentos: 0,
      status: 'ativo',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20man%20smiling%20corporate%20headshot%20portrait%20simple%20white%20background%20clean%20modern%20style&width=100&height=100&seq=14&orientation=squarish',
      saldoReais: 0,
      premiosRecebidos: [],
      historicoEstornos: []
    },
    {
      id: 15,
      nome: 'Amanda Ferreira',
      email: 'amanda.ferreira@empresa.com',
      departamento: 'Qualidade',
      cargo: 'Analista de Qualidade',
      publicoAlvo: 'PF',
      atendimentos: 0,
      status: 'ativo',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20smiling%20corporate%20headshot%20portrait%20simple%20white%20background%20clean%20modern%20style&width=100&height=100&seq=15&orientation=squarish',
      saldoReais: 0,
      premiosRecebidos: [],
      historicoEstornos: []
    }
  ]);

  const [participantes, setParticipantes] = useState<Participante[]>([
    // IDs 1-12 já estão vinculados à campanha
    ...todosParticipantes.filter(p => p.id <= 12)
  ]);

  // Participantes disponíveis para vincular (não estão na campanha)
  const participantesDisponiveis = todosParticipantes.filter(
    p => !participantes.some(pc => pc.id === p.id)
  );

  const filteredParticipantes = participantes.filter(p => {
    const matchesSearch = p.nome.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         p.email.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === 'todos' || p.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const filteredParticipantesVincular = participantesDisponiveis.filter(p => {
    const matchesSearch = p.nome.toLowerCase().includes(searchVincular.toLowerCase()) ||
                         p.email.toLowerCase().includes(searchVincular.toLowerCase()) ||
                         p.departamento.toLowerCase().includes(searchVincular.toLowerCase());
    return matchesSearch && p.status === 'ativo'; // Apenas participantes ativos podem ser vinculados
  });

  const handleToggleSelecao = (id: number) => {
    setParticipantesSelecionados(prev => 
      prev.includes(id) ? prev.filter(pId => pId !== id) : [...prev, id]
    );
  };

  const handleSelecionarTodos = () => {
    if (participantesSelecionados.length === filteredParticipantesVincular.length) {
      setParticipantesSelecionados([]);
    } else {
      setParticipantesSelecionados(filteredParticipantesVincular.map(p => p.id));
    }
  };

  const handleVincularParticipantes = () => {
    const novosParticipantes = todosParticipantes.filter(p => 
      participantesSelecionados.includes(p.id)
    );
    setParticipantes([...participantes, ...novosParticipantes]);
    setParticipantesSelecionados([]);
    setSearchVincular('');
    setShowVincularModal(false);
  };

  const handleVerEstornos = (participante: Participante) => {
    setParticipanteSelecionado(participante);
    setShowEstornoModal(true);
  };

  const handleEditarParticipante = (participante: Participante) => {
    setParticipanteSelecionado(participante);
    setShowEditModal(true);
  };

  const handleBloquearParticipante = (participante: Participante) => {
    setParticipantes(participantes.map(p => 
      p.id === participante.id ? { ...p, status: 'bloqueado' } : p
    ));
  };

  const handleDesbloquearParticipante = (participante: Participante) => {
    setParticipantes(participantes.map(p => 
      p.id === participante.id ? { ...p, status: 'ativo' } : p
    ));
  };

  const handleAprovarAnalise = (participante: Participante) => {
    setParticipanteSelecionado(participante);
    setShowAnaliseModal(true);
  };

  const handleConfirmarAprovacao = () => {
    if (participanteSelecionado) {
      setParticipantes(participantes.map(p => 
        p.id === participanteSelecionado.id ? { ...p, status: 'ativo' } : p
      ));
      setShowAnaliseModal(false);
      setParticipanteSelecionado(null);
    }
  };

  const handleRejeitarAnalise = () => {
    if (participanteSelecionado) {
      setParticipantes(participantes.map(p => 
        p.id === participanteSelecionado.id ? { ...p, status: 'bloqueado' } : p
      ));
      setShowAnaliseModal(false);
      setParticipanteSelecionado(null);
    }
  };

  const handleSalvarEdicao = () => {
    if (participanteSelecionado) {
      setParticipantes(participantes.map(p => 
        p.id === participanteSelecionado.id ? participanteSelecionado : p
      ));
      setShowEditModal(false);
      setParticipanteSelecionado(null);
    }
  };

  const handleSolicitarEstorno = () => {
    if (participanteSelecionado && novoEstorno.valor && novoEstorno.motivo) {
      const novoEstornoCompleto = {
        id: Date.now(),
        valor: parseFloat(novoEstorno.valor),
        motivo: novoEstorno.motivo,
        solicitadoPor: 'João Silva - Administrador',
        dataHora: new Date().toLocaleString('pt-BR'),
        status: 'pendente' as const
      };

      setParticipantes(participantes.map(p => 
        p.id === participanteSelecionado.id 
          ? { 
              ...p, 
              historicoEstornos: [...(p.historicoEstornos || []), novoEstornoCompleto]
            }
          : p
      ));

      setParticipanteSelecionado({
        ...participanteSelecionado,
        historicoEstornos: [...(participanteSelecionado.historicoEstornos || []), novoEstornoCompleto]
      });

      setNovoEstorno({ valor: '', motivo: '' });
    }
  };

  const handleAprovarEstorno = (estornoId: number) => {
    if (participanteSelecionado) {
      const estornoAtualizado = participanteSelecionado.historicoEstornos?.map(e =>
        e.id === estornoId ? { ...e, status: 'aprovado' as const } : e
      ) || [];

      setParticipantes(participantes.map(p => 
        p.id === participanteSelecionado.id 
          ? { ...p, historicoEstornos: estornoAtualizado }
          : p
      ));

      setParticipanteSelecionado({
        ...participanteSelecionado,
        historicoEstornos: estornoAtualizado
      });
    }
  };

  const handleRejeitarEstorno = (estornoId: number) => {
    if (participanteSelecionado) {
      const estornoAtualizado = participanteSelecionado.historicoEstornos?.map(e =>
        e.id === estornoId ? { ...e, status: 'rejeitado' as const } : e
      ) || [];

      setParticipantes(participantes.map(p => 
        p.id === participanteSelecionado.id 
          ? { ...p, historicoEstornos: estornoAtualizado }
          : p
      ));

      setParticipanteSelecionado({
        ...participanteSelecionado,
        historicoEstornos: estornoAtualizado
      });
    }
  };

  const getTotalEstornos = (historicoEstornos?: Array<any>) => {
    return historicoEstornos?.filter(e => e.status === 'aprovado').reduce((total, e) => total + e.valor, 0) || 0;
  };

  const getSaldoLiquido = (participante: Participante) => {
    const totalEstornos = getTotalEstornos(participante.historicoEstornos);
    return (participante.saldoReais || 0) - totalEstornos;
  };

  const getEstornoStatusColor = (status: string) => {
    const colors = {
      'pendente': 'bg-yellow-100 text-yellow-800',
      'aprovado': 'bg-emerald-100 text-emerald-800',
      'rejeitado': 'bg-red-100 text-red-800'
    };
    return colors[status as keyof typeof colors] || 'bg-gray-100 text-gray-800';
  };

  const getPublicoAlvoColor = (publicoAlvo: string) => {
    const colors: Record<string, string> = {
      'PF': 'bg-blue-100 text-blue-800',
      'PJ': 'bg-purple-100 text-purple-800',
      'MEI': 'bg-green-100 text-green-800',
      'CLT': 'bg-orange-100 text-orange-800',
      'AUTÔNOMO': 'bg-teal-100 text-teal-800',
      'REPRESENTANTE': 'bg-indigo-100 text-indigo-800',
      'DISTRIBUIDOR': 'bg-pink-100 text-pink-800'
    };
    return colors[publicoAlvo] || 'bg-gray-100 text-gray-800';
  };

  const getTipoIcon = (publicoAlvo: string) => {
    const icons: Record<string, string> = {
      'PF': 'ri-user-line',
      'PJ': 'ri-building-line',
      'MEI': 'ri-store-line',
      'CLT': 'ri-briefcase-line',
      'AUTÔNOMO': 'ri-user-star-line',
      'REPRESENTANTE': 'ri-user-voice-line',
      'DISTRIBUIDOR': 'ri-truck-line'
    };
    return icons[publicoAlvo] || 'ri-user-line';
  };

  const getStatusColor = (status: string) => {
    switch(status) {
      case 'ativo': return 'bg-green-100 text-green-800';
      case 'inativo': return 'bg-gray-100 text-gray-800';
      case 'bloqueado': return 'bg-red-100 text-red-800';
      case 'em_analise': return 'bg-orange-100 text-orange-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getStatusLabel = (status: string) => {
    switch(status) {
      case 'ativo': return 'Ativo';
      case 'inativo': return 'Inativo';
      case 'bloqueado': return 'Bloqueado';
      case 'em_analise': return 'Em Análise';
      default: return status;
    }
  };

  const getAtendimentosColor = (atendimentos: number) => {
    if (atendimentos >= 1 && atendimentos <= 3) return 'bg-blue-100 text-blue-800';
    if (atendimentos >= 4 && atendimentos <= 7) return 'bg-yellow-100 text-yellow-800';
    if (atendimentos >= 8 && atendimentos <= 12) return 'bg-red-100 text-red-800';
    if (atendimentos >= 13) return 'bg-green-100 text-green-800';
    return 'bg-gray-100 text-gray-800';
  };

  const getAtendimentosLabel = (atendimentos: number) => {
    if (atendimentos >= 1 && atendimentos <= 3) return `${atendimentos} tickets`;
    if (atendimentos >= 4 && atendimentos <= 7) return `${atendimentos} tickets`;
    if (atendimentos >= 8 && atendimentos <= 12) return `${atendimentos} tickets`;
    if (atendimentos >= 13) return `${atendimentos} tickets`;
    return `${atendimentos} tickets`;
  };

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div>
          <div className="flex items-center space-x-3 mb-2">
            <div className="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-megaphone-line text-white"></i>
              </div>
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">{campanhaAtual.nome}</h1>
              <div className="flex items-center space-x-3 mt-1">
                <p className="text-sm text-gray-600">
                  <i className="ri-calendar-line mr-1"></i>
                  {campanhaAtual.periodo}
                </p>
                <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                  {campanhaAtual.status === 'ativa' ? 'Ativa' : 'Inativa'}
                </span>
              </div>
            </div>
          </div>
          <p className="text-gray-600 mt-2">Gerencie os participantes e suas informações</p>
        </div>

        {/* Filters */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
            <div className="flex flex-col md:flex-row md:items-center space-y-4 md:space-y-0 md:space-x-4">
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-search-line text-gray-400"></i>
                  </div>
                </div>
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                  placeholder="Buscar participantes..."
                />
              </div>
              
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm pr-8"
              >
                <option value="todos">Todos os Status</option>
                <option value="ativo">Ativos</option>
                <option value="inativo">Inativos</option>
                <option value="bloqueado">Bloqueados</option>
                <option value="em_analise">Em Análise</option>
              </select>
            </div>

            <div className="flex items-center space-x-3">
              <span className="text-sm text-gray-600">
                {filteredParticipantes.length} de {participantes.length} participantes
              </span>
              <button
                onClick={() => setShowVincularModal(true)}
                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-user-add-line"></i>
                </div>
                <span>Vincular Participantes</span>
              </button>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Participante
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Departamento
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Cargo
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Público-Alvo
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    ATENDIMENTOS (30 DIAS)
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredParticipantes.map((participante) => (
                  <tr key={participante.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <img
                          src={participante.avatar}
                          alt={participante.nome}
                          className="w-10 h-10 rounded-full object-cover"
                        />
                        <div className="ml-4">
                          <div className="text-sm font-medium text-gray-900">{participante.nome}</div>
                          <div className="text-sm text-gray-500">{participante.email}</div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="text-sm text-gray-900">{participante.departamento}</span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="text-sm text-gray-900">{participante.cargo}</span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex items-center gap-1.5 px-3 py-1 text-xs font-semibold rounded-full whitespace-nowrap ${getPublicoAlvoColor(participante.publicoAlvo)}`}>
                        <i className={`${getTipoIcon(participante.publicoAlvo)}`}></i>
                        {participante.publicoAlvo}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(participante.status)}`}>
                        {getStatusLabel(participante.status)}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full whitespace-nowrap ${getAtendimentosColor(participante.atendimentos)}`}>
                        {getAtendimentosLabel(participante.atendimentos)}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <div className="flex items-center justify-end space-x-2">
                        {participante.status === 'bloqueado' && (
                          <>
                            <button
                              onClick={() => handleVerEstornos(participante)}
                              className="text-orange-600 hover:text-orange-800 cursor-pointer"
                              title="Gerenciar Estornos"
                            >
                              <div className="w-5 h-5 flex items-center justify-center">
                                <i className="ri-refund-line"></i>
                              </div>
                            </button>
                            <button
                              onClick={() => handleDesbloquearParticipante(participante)}
                              className="text-green-600 hover:text-green-800 cursor-pointer"
                              title="Desbloquear Participante"
                            >
                              <div className="w-5 h-5 flex items-center justify-center">
                                <i className="ri-lock-unlock-line"></i>
                              </div>
                            </button>
                          </>
                        )}
                        {participante.status === 'em_analise' && (
                          <button
                            onClick={() => handleAprovarAnalise(participante)}
                            className="text-blue-600 hover:text-blue-800 cursor-pointer"
                            title="Analisar Participante"
                          >
                            <div className="w-5 h-5 flex items-center justify-center">
                              <i className="ri-search-eye-line"></i>
                            </div>
                          </button>
                        )}
                        {participante.status !== 'bloqueado' && participante.status !== 'em_analise' && (
                          <button
                            onClick={() => handleBloquearParticipante(participante)}
                            className="text-red-600 hover:text-red-800 cursor-pointer"
                            title="Bloquear Participante"
                          >
                            <div className="w-5 h-5 flex items-center justify-center">
                              <i className="ri-lock-line"></i>
                            </div>
                          </button>
                        )}
                        <button
                          onClick={() => handleEditarParticipante(participante)}
                          className="text-blue-600 hover:text-blue-800 cursor-pointer"
                          title="Editar"
                        >
                          <div className="w-5 h-5 flex items-center justify-center">
                            <i className="ri-edit-line"></i>
                          </div>
                        </button>
                        <button
                          className="text-red-600 hover:text-red-800 cursor-pointer"
                          title="Excluir"
                        >
                          <div className="w-5 h-5 flex items-center justify-center">
                            <i className="ri-delete-bin-line"></i>
                          </div>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {filteredParticipantes.length === 0 && (
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-group-line text-gray-400 text-2xl"></i>
                </div>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Nenhum participante encontrado</h3>
              <p className="text-gray-600 mb-4">Tente ajustar os filtros de busca</p>
            </div>
          )}
        </div>

        {/* Modal de Análise de Informações Divergentes */}
        {showAnaliseModal && participanteSelecionado && participanteSelecionado.informacoesDivergentes && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg w-full max-w-3xl mx-4 max-h-[90vh] overflow-y-auto">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-200">
                <div className="flex items-center space-x-4">
                  <img
                    src={participanteSelecionado.avatar}
                    alt={participanteSelecionado.nome}
                    className="w-12 h-12 rounded-full object-cover"
                  />
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900">Análise de Informações Divergentes</h3>
                    <p className="text-sm text-gray-600">{participanteSelecionado.nome}</p>
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                      Em Análise
                    </span>
                  </div>
                </div>
                <button
                  onClick={() => setShowAnaliseModal(false)}
                  className="text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-close-line text-xl"></i>
                  </div>
                </button>
              </div>

              <div className="p-6">
                {/* Informações de Análise */}
                <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-6">
                  <div className="flex items-center space-x-2 mb-2">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-alert-line text-orange-600"></i>
                    </div>
                    <h4 className="text-sm font-semibold text-orange-800">Motivo da Análise</h4>
                  </div>
                  <p className="text-sm text-orange-700 mb-2">{participanteSelecionado.informacoesDivergentes.motivoAnalise}</p>
                  <p className="text-xs text-orange-600">
                    <i className="ri-time-line mr-1"></i>
                    Solicitado em: {participanteSelecionado.informacoesDivergentes.dataAnalise}
                  </p>
                </div>

                {/* Comparação de Informações */}
                <div className="space-y-6">
                  <h4 className="text-lg font-semibold text-gray-900">Comparação de Informações</h4>
                  
                  {/* Email */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                      <div className="flex items-center space-x-2 mb-2">
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-database-line text-blue-600"></i>
                        </div>
                        <h5 className="text-sm font-semibold text-blue-800">Email na Plataforma</h5>
                      </div>
                      <p className="text-sm text-blue-700 font-mono bg-blue-100 px-2 py-1 rounded">
                        {participanteSelecionado.informacoesDivergentes.emailPlataforma}
                      </p>
                    </div>
                    <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                      <div className="flex items-center space-x-2 mb-2">
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-user-line text-red-600"></i>
                        </div>
                        <h5 className="text-sm font-semibold text-red-800">Email Informado pelo Usuário</h5>
                      </div>
                      <p className="text-sm text-red-700 font-mono bg-red-100 px-2 py-1 rounded">
                        {participanteSelecionado.informacoesDivergentes.emailInformado}
                      </p>
                    </div>
                  </div>

                  {/* Telefone */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                      <div className="flex items-center space-x-2 mb-2">
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-database-line text-blue-600"></i>
                        </div>
                        <h5 className="text-sm font-semibold text-blue-800">Telefone na Plataforma</h5>
                      </div>
                      <p className="text-sm text-blue-700 font-mono bg-blue-100 px-2 py-1 rounded">
                        {participanteSelecionado.informacoesDivergentes.telefonePlataforma}
                      </p>
                    </div>
                    <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                      <div className="flex items-center space-x-2 mb-2">
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-user-line text-red-600"></i>
                        </div>
                        <h5 className="text-sm font-semibold text-red-800">Telefone Informado pelo Usuário</h5>
                      </div>
                      <p className="text-sm text-red-700 font-mono bg-red-100 px-2 py-1 rounded">
                        {participanteSelecionado.informacoesDivergentes.telefoneInformado}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Botões de Ação */}
                <div className="flex items-center justify-end space-x-3 mt-8 pt-6 border-t border-gray-200">
                  <button
                    onClick={() => setShowAnaliseModal(false)}
                    className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={handleRejeitarAnalise}
                    className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Rejeitar e Bloquear
                  </button>
                  <button
                    onClick={handleConfirmarAprovacao}
                    className="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Aprovar e Ativar
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal de Edição */}
        {showEditModal && participanteSelecionado && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-200">
                <div className="flex items-center space-x-4">
                  <img
                    src={participanteSelecionado.avatar}
                    alt={participanteSelecionado.nome}
                    className="w-12 h-12 rounded-full object-cover"
                  />
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900">Editar Participante</h3>
                    <p className="text-sm text-gray-600">{participanteSelecionado.email}</p>
                  </div>
                </div>
                <button
                  onClick={() => setShowEditModal(false)}
                  className="text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-close-line text-xl"></i>
                  </div>
                </button>
              </div>

              <div className="p-6">
                <div className="space-y-6">
                  {/* Informações Básicas */}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-4">Informações Básicas</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Nome Completo</label>
                        <input
                          type="text"
                          value={participanteSelecionado.nome}
                          onChange={(e) => setParticipanteSelecionado({ ...participanteSelecionado, nome: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                        <input
                          type="email"
                          value={participanteSelecionado.email}
                          onChange={(e) => setParticipanteSelecionado({ ...participanteSelecionado, email: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Departamento</label>
                        <input
                          type="text"
                          value={participanteSelecionado.departamento}
                          onChange={(e) => setParticipanteSelecionado({ ...participanteSelecionado, departamento: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Cargo</label>
                        <input
                          type="text"
                          value={participanteSelecionado.cargo}
                          onChange={(e) => setParticipanteSelecionado({ ...participanteSelecionado, cargo: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Status e Atendimentos */}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-4">Status e Atividade</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
                        <select
                          value={participanteSelecionado.status}
                          onChange={(e) => setParticipanteSelecionado({ ...participanteSelecionado, status: e.target.value as 'ativo' | 'inativo' | 'bloqueado' })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm pr-8"
                        >
                          <option value="ativo">Ativo</option>
                          <option value="inativo">Inativo</option>
                          <option value="bloqueado">Bloqueado</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Atendimentos (30 dias)</label>
                        <input
                          type="number"
                          value={participanteSelecionado.atendimentos}
                          onChange={(e) => setParticipanteSelecionado({ ...participanteSelecionado, atendimentos: Number(e.target.value) })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                          min="0"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Informações Financeiras */}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-4">Informações Financeiras</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                        <div className="flex items-center justify-between">
                          <div>
                            <p className="text-sm font-medium text-blue-700">Saldo Total</p>
                            <p className="text-2xl font-bold text-blue-900 mt-1">
                              R$ {(participanteSelecionado.saldoReais || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                            </p>
                          </div>
                          <div className="w-10 h-10 rounded-lg bg-blue-500 flex items-center justify-center">
                            <div className="w-5 h-5 flex items-center justify-center">
                              <i className="ri-wallet-line text-white"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4">
                        <div className="flex items-center justify-between">
                          <div>
                            <p className="text-sm font-medium text-emerald-700">Prêmios Recebidos</p>
                            <p className="text-2xl font-bold text-emerald-900 mt-1">
                              {participanteSelecionado.premiosRecebidos?.length || 0}
                            </p>
                          </div>
                          <div className="w-10 h-10 rounded-lg bg-emerald-500 flex items-center justify-center">
                            <div className="w-5 h-5 flex items-center justify-center">
                              <i className="ri-gift-line text-white"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Botões de Ação */}
                <div className="flex items-center justify-end space-x-3 mt-6 pt-6 border-t border-gray-200">
                  <button
                    onClick={() => setShowEditModal(false)}
                    className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={handleSalvarEdicao}
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Salvar Alterações
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal de Gestão de Estornos */}
        {showEstornoModal && participanteSelecionado && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg w-full max-w-4xl mx-4 max-h-[90vh] overflow-y-auto">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-200">
                <div className="flex items-center space-x-4">
                  <img
                    src={participanteSelecionado.avatar}
                    alt={participanteSelecionado.nome}
                    className="w-12 h-12 rounded-full object-cover"
                  />
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900">{participanteSelecionado.nome}</h3>
                    <p className="text-sm text-gray-600">{participanteSelecionado.email}</p>
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
                      Participante Bloqueado
                    </span>
                  </div>
                </div>
                <button
                  onClick={() => setShowEstornoModal(false)}
                  className="text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-close-line text-xl"></i>
                  </div>
                </button>
              </div>

              <div className="p-6">
                {/* Resumo Financeiro */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm font-medium text-blue-700">Saldo Total</p>
                        <p className="text-2xl font-bold text-blue-900 mt-1">
                          R$ {(participanteSelecionado.saldoReais || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                        </p>
                      </div>
                      <div className="w-10 h-10 rounded-lg bg-blue-500 flex items-center justify-center">
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-wallet-line text-white"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm font-medium text-red-700">Total Estornado</p>
                        <p className="text-2xl font-bold text-red-900 mt-1">
                          R$ {getTotalEstornos(participanteSelecionado.historicoEstornos).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                        </p>
                      </div>
                      <div className="w-10 h-10 rounded-lg bg-red-500 flex items-center justify-center">
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-refund-line text-white"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm font-medium text-emerald-700">Saldo Líquido</p>
                        <p className="text-2xl font-bold text-emerald-900 mt-1">
                          R$ {getSaldoLiquido(participanteSelecionado).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                        </p>
                      </div>
                      <div className="w-10 h-10 rounded-lg bg-emerald-500 flex items-center justify-center">
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-money-dollar-circle-line text-white"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Prêmios Recebidos */}
                <div className="mb-8">
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">Prêmios Recebidos</h4>
                  <div className="bg-gray-50 rounded-lg p-4">
                    {participanteSelecionado.premiosRecebidos && participanteSelecionado.premiosRecebidos.length > 0 ? (
                      <div className="space-y-3">
                        {participanteSelecionado.premiosRecebidos.map((premio) => (
                          <div key={premio.id} className="flex items-center justify-between bg-white rounded-lg p-3 border border-gray-200">
                            <div className="flex items-center space-x-3">
                              <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                                premio.tipo === 'dinheiro' ? 'bg-green-100' :
                                premio.tipo === 'produto' ? 'bg-blue-100' : 'bg-purple-100'
                              }`}>
                                <div className="w-4 h-4 flex items-center justify-center">
                                  <i className={`${
                                    premio.tipo === 'dinheiro' ? 'ri-money-dollar-circle-line text-green-600' :
                                    premio.tipo === 'produto' ? 'ri-gift-line text-blue-600' : 'ri-plane-line text-purple-600'
                                  }`}></i>
                                </div>
                              </div>
                              <div>
                                <p className="text-sm font-medium text-gray-900">{premio.nome}</p>
                                <p className="text-xs text-gray-500">{new Date(premio.data).toLocaleDateString('pt-BR')}</p>
                              </div>
                            </div>
                            <div className="text-right">
                              <p className="text-sm font-bold text-gray-900">
                                R$ {premio.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                              </p>
                              <p className="text-xs text-gray-500 capitalize">{premio.tipo}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="text-sm text-gray-500 text-center py-4">Nenhum prêmio recebido</p>
                    )}
                  </div>
                </div>

                {/* Novo Estorno */}
                <div className="mb-8">
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">Solicitar Novo Estorno</h4>
                  <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Valor do Estorno</label>
                        <input
                          type="number"
                          step="0.01"
                          value={novoEstorno.valor}
                          onChange={(e) => setNovoEstorno({ ...novoEstorno, valor: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-sm"
                          placeholder="0,00"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Motivo do Estorno</label>
                        <input
                          type="text"
                          value={novoEstorno.motivo}
                          onChange={(e) => setNovoEstorno({ ...novoEstorno, motivo: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-sm"
                          placeholder="Descreva o motivo do estorno"
                        />
                      </div>
                    </div>
                    <button
                      onClick={handleSolicitarEstorno}
                      disabled={!novoEstorno.valor || !novoEstorno.motivo}
                      className="bg-orange-600 hover:bg-orange-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Solicitar Estorno
                    </button>
                  </div>
                </div>

                {/* Histórico de Estornos */}
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">Histórico de Estornos</h4>
                  <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
                    {participanteSelecionado.historicoEstornos && participanteSelecionado.historicoEstornos.length > 0 ? (
                      <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                          <thead className="bg-gray-50">
                            <tr>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Data/Hora
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Valor
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Motivo
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Solicitado Por
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Status
                              </th>
                              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Ações
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {participanteSelecionado.historicoEstornos.map((estorno) => (
                              <tr key={estorno.id} className="hover:bg-gray-50">
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                  {estorno.dataHora}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                  R$ {estorno.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                </td>
                                <td className="px-6 py-4 text-sm text-gray-900">
                                  {estorno.motivo}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                  {estorno.solicitadoPor}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getEstornoStatusColor(estorno.status)}`}>
                                    {estorno.status.charAt(0).toUpperCase() + estorno.status.slice(1)}
                                  </span>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                  {estorno.status === 'pendente' && (
                                    <div className="flex items-center justify-end space-x-2">
                                      <button
                                        onClick={() => handleAprovarEstorno(estorno.id)}
                                        className="text-emerald-600 hover:text-emerald-800 cursor-pointer"
                                        title="Aprovar Estorno"
                                      >
                                        <div className="w-5 h-5 flex items-center justify-center">
                                          <i className="ri-check-line"></i>
                                        </div>
                                      </button>
                                      <button
                                        onClick={() => handleRejeitarEstorno(estorno.id)}
                                        className="text-red-600 hover:text-red-800 cursor-pointer"
                                        title="Rejeitar Estorno"
                                      >
                                        <div className="w-5 h-5 flex items-center justify-center">
                                          <i className="ri-close-line"></i>
                                        </div>
                                      </button>
                                    </div>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="text-center py-8">
                        <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
                          <div className="w-6 h-6 flex items-center justify-center">
                            <i className="ri-refund-line text-gray-400 text-xl"></i>
                          </div>
                        </div>
                        <p className="text-sm text-gray-500">Nenhum estorno registrado</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal de Vincular Participantes */}
        {showVincularModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg w-full max-w-5xl mx-4 max-h-[90vh] overflow-y-auto">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-200">
                <div>
                  <h3 className="text-xl font-semibold text-gray-900">Vincular Participantes à Campanha</h3>
                  <p className="text-sm text-gray-600 mt-1">Selecione os participantes que deseja adicionar à campanha</p>
                </div>
                <button
                  onClick={() => {
                    setShowVincularModal(false);
                    setParticipantesSelecionados([]);
                    setSearchVincular('');
                  }}
                  className="text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-close-line text-xl"></i>
                  </div>
                </button>
              </div>

              <div className="p-6">
                {/* Busca e Seleção */}
                <div className="flex items-center justify-between mb-6">
                  <div className="relative flex-1 max-w-md">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-search-line text-gray-400"></i>
                      </div>
                    </div>
                    <input
                      type="text"
                      value={searchVincular}
                      onChange={(e) => setSearchVincular(e.target.value)}
                      className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm w-full"
                      placeholder="Buscar por nome, email ou departamento..."
                    />
                  </div>
                  <div className="flex items-center space-x-3">
                    <span className="text-sm text-gray-600">
                      {participantesSelecionados.length} selecionado(s)
                    </span>
                    {filteredParticipantesVincular.length > 0 && (
                      <button
                        onClick={handleSelecionarTodos}
                        className="px-3 py-2 text-sm text-blue-600 hover:text-blue-700 font-medium cursor-pointer whitespace-nowrap"
                      >
                        {participantesSelecionados.length === filteredParticipantesVincular.length 
                          ? 'Desmarcar Todos' 
                          : 'Selecionar Todos'}
                      </button>
                    )}
                  </div>
                </div>

                {/* Lista de Participantes Disponíveis */}
                {filteredParticipantesVincular.length > 0 ? (
                  <div className="border border-gray-200 rounded-lg overflow-hidden">
                    <div className="max-h-96 overflow-y-auto">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50 sticky top-0">
                          <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-12">
                              <input
                                type="checkbox"
                                checked={participantesSelecionados.length === filteredParticipantesVincular.length && filteredParticipantesVincular.length > 0}
                                onChange={handleSelecionarTodos}
                                className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer"
                              />
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Participante
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Departamento
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Cargo
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Público-Alvo
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {filteredParticipantesVincular.map((participante) => (
                            <tr 
                              key={participante.id} 
                              className={`hover:bg-gray-50 cursor-pointer ${
                                participantesSelecionados.includes(participante.id) ? 'bg-blue-50' : ''
                              }`}
                              onClick={() => handleToggleSelecao(participante.id)}
                            >
                              <td className="px-6 py-4 whitespace-nowrap">
                                <input
                                  type="checkbox"
                                  checked={participantesSelecionados.includes(participante.id)}
                                  onChange={() => handleToggleSelecao(participante.id)}
                                  className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer"
                                  onClick={(e) => e.stopPropagation()}
                                />
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex items-center">
                                  <img
                                    src={participante.avatar}
                                    alt={participante.nome}
                                    className="w-10 h-10 rounded-full object-cover"
                                  />
                                  <div className="ml-4">
                                    <div className="text-sm font-medium text-gray-900">{participante.nome}</div>
                                    <div className="text-sm text-gray-500">{participante.email}</div>
                                  </div>
                                </div>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <span className="text-sm text-gray-900">{participante.departamento}</span>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <span className="text-sm text-gray-900">{participante.cargo}</span>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <span className={`inline-flex items-center gap-1.5 px-3 py-1 text-xs font-semibold rounded-full whitespace-nowrap ${getPublicoAlvoColor(participante.publicoAlvo)}`}>
                                  <i className={`${getTipoIcon(participante.publicoAlvo)}`}></i>
                                  {participante.publicoAlvo}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-12 border border-gray-200 rounded-lg">
                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <div className="w-8 h-8 flex items-center justify-center">
                        <i className="ri-user-search-line text-gray-400 text-2xl"></i>
                      </div>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                      {participantesDisponiveis.length === 0 
                        ? 'Todos os participantes já estão vinculados' 
                        : 'Nenhum participante encontrado'}
                    </h3>
                    <p className="text-gray-600">
                      {participantesDisponiveis.length === 0 
                        ? 'Não há mais participantes disponíveis para vincular a esta campanha' 
                        : 'Tente ajustar os termos de busca'}
                    </p>
                  </div>
                )}

                {/* Informação sobre participantes não disponíveis */}
                {participantesDisponiveis.some(p => p.status !== 'ativo') && (
                  <div className="mt-4 bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                    <div className="flex items-start space-x-2">
                      <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                        <i className="ri-information-line text-yellow-600"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-yellow-800">Informação</p>
                        <p className="text-sm text-yellow-700 mt-1">
                          Apenas participantes com status "Ativo" podem ser vinculados à campanha. 
                          Participantes bloqueados, inativos ou em análise não aparecem na lista.
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Footer com Botões */}
              <div className="flex items-center justify-between p-6 border-t border-gray-200 bg-gray-50">
                <div className="text-sm text-gray-600">
                  {participantesDisponiveis.length} participante(s) disponível(is) para vincular
                </div>
                <div className="flex items-center space-x-3">
                  <button
                    onClick={() => {
                      setShowVincularModal(false);
                      setParticipantesSelecionados([]);
                      setSearchVincular('');
                    }}
                    className="px-4 py-2 text-gray-700 bg-white hover:bg-gray-100 border border-gray-300 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={handleVincularParticipantes}
                    disabled={participantesSelecionados.length === 0}
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2"
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-check-line"></i>
                    </div>
                    <span>Vincular {participantesSelecionados.length > 0 ? `(${participantesSelecionados.length})` : ''}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}